import {
  emptyString,
  globalSystemConstants,
  loginConstants,
  successMessages,
  toastTypes,
} from "../../constants";
import { authService } from "../../services";
import { custom, failure, success, withSpinner } from "./utilities";
import { customToast } from "../../shared";
import {
  globalConstants,
  viewPathConstants,
} from "../../constants/global.constants";

const { LOGIN } = viewPathConstants;

//This action is called when user click on login
const login = (userData) => {
  return (dispatch) => {
    return withSpinner(dispatch, loginConstants.LOGIN_SPINNER, () =>
      authService
        .login(userData)
        .then(
          (response) => {
            const updateReducer = () => {
              dispatch(
                success(response, loginConstants.LOGIN, globalConstants.SUCCESS)
              );
              dispatch(getBrandsWithFeatureFlags());
            };
            return { response, updateReducer };
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            throw error;
          }
        )
    );
  };
};

//This action is called when user click on login
const handleAdminToken = (token) => {
  return (dispatch) => {
    authService.handleAdminToken(token);
    dispatch(
      success(token, loginConstants.ADMIN_TOKEN, globalConstants.SUCCESS)
    );
  };
};

const logout = () => {
  authService.logout();
};

// Action for sending forgot-password email
const sendForgotPasswordEmail = (email) => {
  return (dispatch) => {
    return withSpinner(dispatch, loginConstants.FORGOT_SPINNER, () =>
      authService
        .sendForgotPasswordEmail(email)
        .then(
          (_response) => {
            customToast(loginConstants.EMAIL_SENT_MESSAGE, toastTypes.SUCCESS);
            dispatch(
              success(
                loginConstants.EMAIL_SENT_MESSAGE,
                loginConstants.FORGOT_PASSWORD
              )
            );
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            dispatch(failure(error[0], loginConstants.FORGOT_PASSWORD));
            throw error;
          }
        )
    );
  };
};

const resetForgotEmailResponse = () => {
  return (dispatch) => {
    dispatch(success(null, loginConstants.RESET_FORGOT_PASSWORD_RESPONSE));
    dispatch(failure(null, loginConstants.RESET_PASSWORD));
  };
};

// Action for resetting password via encrypted params
const resetPasswordByEncryptedParams = (body) => {
  return (dispatch) => {
    return withSpinner(dispatch, loginConstants.RESET_PASSWORD_SPINNER, () =>
      authService
        .resetPasswordByEncryptedParams(body)
        .then(
          (_response) => {
            customToast(
              successMessages.RESET_PASSWORD_SUCCESS,
              toastTypes.SUCCESS
            );

            dispatch(
              success(
                successMessages.RESET_PASSWORD_SUCCESS,
                loginConstants.RESET_PASSWORD
              )
            );
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            dispatch(failure(error[0], loginConstants.RESET_PASSWORD));
            throw error;
          }
        )
    );
  };
};

//Sending help Message
const sendHelpMessage = (body) => {
  return (dispatch) => {
    withSpinner(dispatch, loginConstants.SEND_HELP_MESSAGE, () =>
      authService
        .sendHelpMessage(body)
        .then(
          (_response) => {
            customToast(
              successMessages.SUBMITTED_SUCCESSFULLY,
              toastTypes.SUCCESS
            );
            dispatch(
              success(
                successMessages.SUBMITTED_SUCCESSFULLY,
                loginConstants.SEND_HELP_MESSAGE
              )
            );
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

const resetHelpMessageResponse = () => {
  return (dispatch) => {
    dispatch(failure(emptyString, loginConstants.SEND_HELP_MESSAGE));
  };
};

// Action to verify user email
const updateUserPassword = (body, callBackFunc) => (dispatch) => {
  withSpinner(dispatch, loginConstants.UPDATE_PASSWORD, () =>
    authService
      .updateUserPassword(body)
      .then(
        (response) => {
          dispatch(success(response, loginConstants.UPDATE_PASSWORD));
          callBackFunc();
          window.location.assign(LOGIN);
        },
        (error) => {
          customToast(error[0], toastTypes.ERROR);
          dispatch(failure(error[0], loginConstants.UPDATE_PASSWORD));
        }
      )
  );
};

// Action to reset update password msg
const resetUpdatedPasswordMsg = () => {
  return (dispatch) => {
    dispatch(failure(emptyString, loginConstants.UPDATE_PASSWORD));
  };
};

//Getting user by id
const getUserById = (userId) => (dispatch) => {
  authService.getUserById(userId).then(
    (response) => dispatch(success(response, loginConstants.LOGIN_USER)),
    (error) => {
      customToast(error[0], toastTypes.ERROR);
    }
  );
};

//Set from hub status
const setFromHub = (data) => (dispatch) => {
  dispatch(custom(data, globalSystemConstants.SET_FROM_HUB));
};

//Get Brands with Features
const getBrandsWithFeatureFlags = () => {
  return (dispatch) => {
    withSpinner(
      dispatch,
      loginConstants.GET_ALL_BRANDS_WITH_FEATURE_FLAGS,
      () =>
        authService
          .getAllBrandsWithFeatureFlags()
          .then(
            (response) => {
              dispatch(
                success(response, loginConstants.GET_ALL_BRANDS_WITH_FEATURE_FLAGS)
              );
            },
            (error) => {
              customToast(error[0], toastTypes.ERROR);
            }
          )
    );
  };
};

//Update Clarity Consent for a user
const updateClarityConsent = (data) => {
  return (dispatch) => {
    return withSpinner(dispatch, loginConstants.UPDATE_CLARITY_CONSENT, () =>
      authService
        .updateClarityConsent(data)
        .then(
          (response) => {
            dispatch(success(response, loginConstants.UPDATE_CLARITY_CONSENT));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            throw error;
          }
        )
    );
  };
};

export const loginActions = {
  login,
  logout,
  setFromHub,
  getUserById,
  sendHelpMessage,
  handleAdminToken,
  updateUserPassword,
  updateClarityConsent,
  sendForgotPasswordEmail,
  resetUpdatedPasswordMsg,
  resetForgotEmailResponse,
  resetHelpMessageResponse,
  getBrandsWithFeatureFlags,
  resetPasswordByEncryptedParams,
};
